module.exports = __webpack_public_path__ + "static/media/adventure-archive-screenshot-7.3b41c30d.jpg";